export const TEST_ID = 'recommendedPartsSection';
